import {
  BriefcaseRegular,
  DismissRegular,
} from '@fluentui/react-icons';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AssignmentResourceItem } from '../../../../Assignments';
import { CommonHomeworkForm } from './CommonHomeworkForm';
import { SelectTeamsAssignmentWithResources } from './NewHomeworkDialog.interfaces';

export interface HomeworkWithAssociatedAssignmentViewProps {
  assignmentData: { name?: string; id?: string };
  selectedHomework?: SelectTeamsAssignmentWithResources;
  selectedHomeworkChanged?: (
    homework: SelectTeamsAssignmentWithResources,
  ) => void;
  removeTeamsAssignmentClicked: () => void;
  selectedDate: Date;
}

export const HomeworkWithAssociatedAssignmentView: FC<
  HomeworkWithAssociatedAssignmentViewProps
> = props => {
  const {
    assignmentData,
    selectedHomework,
    removeTeamsAssignmentClicked,
    selectedHomeworkChanged,
    selectedDate,
  } = props;
  const { t } = useTranslation();
  const selectedResources = selectedHomework
    ? selectedHomework.resources.map(a => (
        <AssignmentResourceItem {...a} editMode={assignmentData.id === ''} />
      ))
    : null;
  const selectedResourcesSection =
    selectedResources?.length === 0 ? (
      <span className="inputLabel">
        {t('classbook:newassignment:dialog_empty_ressources', { defaultValue: 'Der Teamaufgabe wurden keine Ressourcen angehangen' })}
      </span>
    ) : (
      selectedResources
    );

  return (
    <div className="flex flex-col homeworkWithAssociatedAssignmentView">
      <span className="inputLabel">
        {t('classbook:newassignment:dialog_connected_teams', { defaultValue: 'Verknüpfte Teamsaufgabe' })}
      </span>
      <div className="teamsAssignmentBtn button">
        <BriefcaseRegular className="assignmenTenantLinktIcon" />
        <div className="label">
          {assignmentData.name && assignmentData.name.length > 0
            ? assignmentData.name
            : t('classbook:teamassignmentdialog:empty_assignment_plan', { defaultValue: 'Kein Titel vorhanden' })}
        </div>
        <DismissRegular
          className="deleteIcon"
          onClick={removeTeamsAssignmentClicked}
        />
      </div>
      <CommonHomeworkForm
        selectedHomework={selectedHomework}
        selectedHomeworkChanged={selectedHomeworkChanged}
        minDate={selectedDate}
      />
      <span className="inputLabel">
        {t('assignment_ressources', { defaultValue: 'Ressourcen' })}
      </span>
      {selectedResourcesSection}
    </div>
  );
};
